import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAuthenticated } from '../store/selectors/AuthSelectors';

export const PrivateRoute = ({ component: Component, ...rest }) => {
    const userIsAuthenticated = useSelector(isAuthenticated);

    return (
        <Route
            {...rest}
            render={(props) =>
                userIsAuthenticated ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
};